import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import styled, { css } from 'styled-components';
/**
 * 20px / 28px
 */
const LargeStyles = css `
  ${fonts.gillSans.light};
  font-size: 18px;
  letter-spacing: normal;
  line-height: 26px;
  margin: 0 0 16px;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 26px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 21px;
    line-height: 32px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 24px;
    line-height: 38px;
  }
`;
/**
 * 18px / 28px
 */
const RegularStyles = css `
  ${fonts.gillSans.light};
  font-size: 16px;
  letter-spacing: normal;
  line-height: 26px;
  margin: 0 0 16px;

  @media ${from(Device.Tablet)} {
    font-size: 16px;
    line-height: 26px;
  }

  @media ${from(Device.Desktop)} {
    font-size: 19px;
    line-height: 33px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 19px;
    line-height: 33px;
  }
`;
/**
 * 16px / 26px
 */
const SmallStyles = css `
  ${fonts.gillSans.regular};
  font-size: 14px;
  letter-spacing: normal;
  line-height: 20px;
  margin: 0 0 16px;

  @media ${from(Device.Tablet)} {
    font-size: 14px;
    line-height: 20px;
  }

  @media ${from(Device.Desktop)} {
    ${fonts.gillSans.semiBold};
    font-size: 14px;
    line-height: 22px;
  }

  @media ${from(Device.DesktopLarge)} {
    font-size: 16px;
    line-height: 22px;
  }
`;
const Paragraph = styled.p `
  ${({ size }) => {
    switch (size) {
        case 'large':
            return LargeStyles;
        case 'regular':
            return RegularStyles;
        case 'small':
            return SmallStyles;
        default:
            break;
    }
}}
`;
export default {
    Paragraph,
    SmallStyles,
    RegularStyles,
    LargeStyles,
};
